import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		isLoggedIn: !!localStorage.getItem("token"),
		userType: localStorage.getItem('userType'),
		// userType: 'Client',
		cartItems: 0,
		wishlistItems: 0,
		userData: {},
		coupen: {},
		buyNGetMDeal: 0,
		loginAlternate: false,
		fullPath: null,
		categories: [],
		stylCategories: [],
		subCategories: [],
	},
	mutations: {
		loginUser(state, item) {
			state.isLoggedIn = item

		},

		LOGIN_ALTERNATE(state, item) {
			state.loginAlternate = item

		},

		lastPage_fullPath(state, item) {
			// console.log(state,item,"fghj")
			state.fullPath = item
		},

		logoutUser(state) {
			axios({
				method: "GET",
				url: "/user/logout",
				headers: {
					"x-auth-token": localStorage.getItem("token")
				}
			}).then(response => {
				if (response.data) {
					state.userType = 'Client'
					state.userData = {}
					state.coupen = {}
					localStorage.setItem("userType", 'Client');
					state.isLoggedIn = false
					state.cartItems = 0
					state.wishlistItems = 0
					localStorage.removeItem("token");
					if (window.location.pathname != '/') {
						router.push('/')
					}
				}
			})
		},
		changeCart(state, item) {
			state.cartItems = item
		},
		changeWishlist(state, item) {
			state.wishlistItems = item
		},
		userData(state, item) {
			state.userData = item
		},
		coupen(state, item) {
			state.coupen = item
		},
		changePicture(state, item) {
			state.userData.image = item
		},
		changeCoverPicture(state, item) {
			state.userData.seller.coverimage = item
		},
		userType(state, item) {
			state.userType = item
			localStorage.setItem("userType", item);
		},
		changeBuyNGetMDeal(state, item) {
			state.buyNGetMDeal = item
		},
		sessionOut(state) {
			localStorage.removeItem("token");
			state.isLoggedIn = false
			router.push('/')
		},
		SET_CATEGORIES(state, categories) {
			state.categories = categories
		},
		SET_STYLCATEGORIES(state, stylCategories) {
			state.stylCategories = stylCategories
		},
		SET_SUBCATEGORIES(state, subCategories) {
			state.subCategories = subCategories
		}
	},
	actions: {
		getCategory({ commit }) {
			axios({
				method: "GET",
				url: "/category/getlist",
			})
				.then((reponse) => {
					commit('SET_CATEGORIES', reponse.data)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getStylCategory({ commit }) {
			axios({
				method: "GET",
				url: "/styl/getlist",
			})
				.then((reponse) => {
					commit('SET_STYLCATEGORIES', reponse.data.data)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getSubCategory({ commit }) {
			// console.log(state.userData._id,"hiiii")

			axios({
				method: "GET",
				url: "/subcategory/getlist",
				params: {
					category: router.currentRoute.query.category,
					styl: router.currentRoute.query.styl,
				},
			})
				.then((reponse) => {
					commit('SET_SUBCATEGORIES', reponse.data.data)
				})
				.catch((err) => {
					console.log(err);
				});
		},

	}

})